import { render } from "./ProductServices.vue?vue&type=template&id=aa9e1f1c&scoped=true"
import script from "./ProductServices.vue?vue&type=script&lang=js"
export * from "./ProductServices.vue?vue&type=script&lang=js"

import "./ProductServices.vue?vue&type=style&index=0&id=aa9e1f1c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa9e1f1c"]])

export default __exports__